import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-[var(--line)] bg-white mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-3">
            <img src="/logo.png" alt="Get Skilled in Days Not Years" className="h-9 w-9 object-contain" />
            <span className="font-display font-extrabold tracking-tight">GET SKILLED IN DAYS NOT YEARS</span>
          </div>
          <p className="text-[var(--ink-2)] text-sm max-w-sm">Get skilled in days, not years. Practical skills, real opportunities — discover, apply, train, certify and progress, all from your phone.</p>
        </div>
        <div>
          <p className="text-xs tracking-label uppercase font-semibold text-[var(--ink-2)] mb-3">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/courses" className="hover:text-[var(--accent)]">All courses</Link></li>
            <li><Link to="/register" className="hover:text-[var(--accent)]">Create account</Link></li>
            <li><Link to="/admin" data-testid="footer-explore-admin-link" className="hover:text-[var(--accent)]">Admin login</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs tracking-label uppercase font-semibold text-[var(--ink-2)] mb-3">Legal</p>
          <ul className="space-y-2 text-sm text-[var(--ink-2)]">
            <li><Link to="/privacy-policy" className="hover:text-[var(--accent)]" data-testid="footer-privacy-link">Privacy policy</Link></li>
            <li><Link to="/refund-policy" className="hover:text-[var(--accent)]" data-testid="footer-refund-link">Refund policy</Link></li>
            <li><Link to="/terms" className="hover:text-[var(--accent)]" data-testid="footer-terms-link">Terms &amp; conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--line)] py-5 px-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-center">
        <span className="text-xs text-[var(--ink-2)]">© {new Date().getFullYear()} Virtual Speedy Services LMS. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-admin-link" title="Restricted — providers & administrators only" className="inline-flex items-center gap-1.5 text-xs font-semibold text-[var(--ink-2)] hover:text-[var(--accent)] transition-colors">
          <Lock size={12} /> Admin Login <span className="text-[var(--ink-2)]/60 font-normal">(restricted)</span>
        </Link>
      </div>
    </footer>
  );
}
